import { ENTERPRISE, FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
const HighlightedProductsHeaderConfig = {
  ['MARKETING']: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.marketing'
    },
    [STARTER]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.starterCard',
      subtitle: 'merchCards.starterCard.description.marketing',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard',
      subtitle: 'merchCards.professionalCard.description.marketing',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.marketing.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard',
      subtitle: 'merchCards.enterpriseCard.description.marketing',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.marketing.enterprise.lowerTierPlus'
    }
  },
  ['SALES']: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.sales'
    },
    [STARTER]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.starterCard',
      subtitle: 'merchCards.starterCard.description.sales',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard',
      subtitle: 'merchCards.professionalCard.description.sales',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.sales.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard',
      subtitle: 'merchCards.enterpriseCard.description.sales',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.sales.enterprise.lowerTierPlus'
    }
  },
  ['SERVICE']: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.service'
    },
    [STARTER]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.starterCard',
      subtitle: 'merchCards.starterCard.description.service',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard',
      subtitle: 'merchCards.professionalCard.description.service',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.service.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard',
      subtitle: 'merchCards.enterpriseCard.description.service',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.service.enterprise.lowerTierPlus'
    }
  },
  ['CMS']: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.cms'
    },
    [STARTER]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.starterCard',
      subtitle: 'merchCards.starterCard.description.cms',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard',
      subtitle: 'merchCards.professionalCard.description.cms',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.content.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard',
      subtitle: 'merchCards.enterpriseCard.description.cms',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.content.enterprise.lowerTierPlus'
    }
  },
  ['OPERATIONS']: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.operations'
    },
    [STARTER]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.starterCard',
      subtitle: 'merchCards.starterCard.description.operations',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlus'
    },
    [PROFESSIONAL]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard',
      subtitle: 'merchCards.professionalCard.description.operations',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.data.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard',
      subtitle: 'merchCards.enterpriseCard.description.operations',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.data.enterprise.lowerTierPlus'
    }
  },
  ['COMMERCE']: {
    [PROFESSIONAL]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard',
      subtitle: 'merchCards.professionalCard.description.commerce',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.commerce.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard',
      subtitle: 'merchCards.enterpriseCard.description.commerce',
      lowerTierPlus: 'pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.commerce.enterprise.lowerTierPlus'
    }
  }
};
export function useHighlightedProductsHeaderConfig(producLine, productLevel) {
  if (!producLine || !productLevel) {
    return HighlightedProductsHeaderConfig;
  }
  return HighlightedProductsHeaderConfig[producLine][productLevel];
}